import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import Grid from '@mui/material/Grid';
import { useAnimate, stagger, motion, useAnimation } from "framer-motion";
import { Box, Typography, duration, scopedCssBaselineClasses } from '@mui/material';
import { useAnimationSeqContext } from '../ContextProviders/AnimationSeqContextProvider';
import ReelSymbol from './ReelSymbol.jsx'
import { useGameStateContext } from '../ContextProviders/GameStateContextProvider';
import Lock from './Lock';

import { createTheme, responsiveFontSizes } from '@mui/material/styles';
import { ThemeProvider } from '@emotion/react';


const staggerMenuItems = stagger(0.1, { startDelay: 0.15 });
const theme = createTheme();
theme.typography.h2 = {
    color: 'rgb(255,255,255)',
    fontSize: '5rem'
}
function Reels(props) {
    var k = 0;
    const gameState = useGameStateContext();


    const lockAnimation = useAnimation();
    const lockAnimationMasterVariants = {
        show: {
            transition: {
                staggerChildren: 0.1,
                delayChildren: 0.5,
            },
        }
    }

    const lockAnimationVariants = {
        init: {
            scale: 0
        },
        hidden: {
            opacity: 0,
            transition: { duration: 0 }
        },
        show: {
            opacity: [1, 1],
            scale: [0, 1.4],
            transition: { times: [0, 1], style: "spring", duration: 0.4 },
        }
    }
    useEffect(() => {
        if (gameState.state === 'Second')
            lockAnimation.start("show");
        else
            lockAnimation.start("hidden");

    }, [gameState.state])

    const handleLockClick = (reelIndex) => {
        gameState.setLock(reelIndex, !gameState.getLock(reelIndex));
    };

    return (
        <Box
            component={motion.div}
            variants={lockAnimationMasterVariants}
            initial="init"
            animate={lockAnimation}
            sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'flex-start',
                alignItems: 'center',
                width: '100%',
                maxWidth: '800px',
                height: '100%',
                paddingTop: '5%',
                paddingBottom: '16%',
                background: `url(${process.env.PUBLIC_URL + '/Images/lowerPart.png'}) no-repeat center center`,
                backgroundSize: '100% 100%',
            }}
        >
            <Box
                className='reels'
                id='reels'
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-around',
                    position: 'relative',
                    overflow: 'hidden',
                    width: '88%',
                    height: '70%'
                }}>
                {
                    props.symbols.map((r, ridx) => (
                        <Box
                            key={ridx}
                            sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'space-around',
                            }}
                            m={1}
                        >
                            {
                                r.map((s, sidx) => (
                                    <ReelSymbol
                                        key={"Reel " + ridx + " Sym " + sidx}
                                        reel={sidx}
                                        row={ridx}
                                        symbolNo={s}
                                        spinning={props.spinning}
                                        matches={props.matches}
                                    />
                                ))
                            }
                        </Box>
                    ))
                }
                {(false && (gameState.state === 'Idle' || gameState.state === 'Second') && (!gameState.response.win)) && (
                    <motion.div
                        className='gameResult'
                        initial={{ opacity: 0.0 }}
                        animate={{ opacity: [0.0, 1.0, 1.0, 0.0], transition: { times: [0, 0.2, 0.8, 1], delay: 0, duration: 4 } }}
                    >
                        <ThemeProvider theme={theme}>
                            <Typography variant="h3" m={1} color="common.white">No Win</Typography>
                            {(gameState.state === 'Second') && (<Typography variant="h5" m={2} color="common.white">Give it a second try. (You can lock some reels now!)</Typography>)}
                        </ThemeProvider>
                    </motion.div>
                )}
                {(false && gameState.state === 'freeGameWait') && (
                    <motion.div
                        className='gameResult'
                        initial={{ opacity: 0.0 }}
                        animate={{ opacity: [0.0, 1.0, 1.0, 0.0], transition: { times: [0, 0.2, 0.8, 1], delay: 0, duration: 4 } }}
                    >
                        <ThemeProvider theme={theme}>
                            <Typography variant="h3" m={1} color="common.white">{gameState.freegames} Freegames left</Typography>
                            {(gameState.state === 'Second') && (<Typography variant="h5" m={2} color="common.white">Give it a second try. (You can lock some reels now!)</Typography>)}
                        </ThemeProvider>
                    </motion.div>
                )}
            </Box>
            <Box
                className='holds'
                id='holds'
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-around',
                    width: '88%',
                    position: 'absolute',
                    bottom: '20%',
                }}
                m={1}>
                {
                    props.symbols[0].map((r, ridx) => (
                        <motion.div
                            key={"Lock" + ridx}
                            variants={lockAnimationVariants}
                            style={{
                                width: '92px',
                                height: '22px',
                                backgroundSize: "cover",
                                backgroundPosition: 'center right',
                                borderRadius: "50%",
                                cursor: 'pointer'
                            }}
                            m={15}
                            onClick={() => handleLockClick(ridx)}
                        >
                            <Lock isClosed={gameState.getLock(ridx)} />
                        </motion.div>
                    ))
                }
            </Box>
        </Box>
    )
}

Reels.propTypes = {
    //reels : PropTypes.number.isRequired,
    //rows : PropTypes.number.isRequired,
    symbols: PropTypes.array.isRequired
}

export default Reels
